import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../state/store';
import { ALL_USERS_ROLE } from '../utils/constants';

/**
 * Custom hook for managing personas data
 * Combines the ALL_USERS_ROLE constant with encompass personas from app state
 * Returns persona names to be used in place of roles
 * @returns Array of persona names including the all users role
 */
export const usePersonas = (): string[] => {
    const appState = useSelector((state: RootState) => state.appSlice);
    const [personas, setPersonas] = useState<string[]>([]);

    useEffect(() => {
        if (appState?.encompassPersonas?.length > 0) {
            setPersonas([ALL_USERS_ROLE, ...appState.encompassPersonas.map(persona => persona.name)]);
        } else {
            // Reset to empty if no personas available
            setPersonas([]);
        }
    }, [appState?.encompassPersonas]);

    return personas;
};
